export function heroIcon() {
    const $html = this.$html;
    const $window = this.$window;
    const $actionBox = $(".hero-icon-action-box");
    const $closeBtn = $(".hero-icon-popup-close");
    const desktopBreakpoint = 1200;
    const isTouch = this.isTouch;
    let ww = $window.outerWidth();

    $closeBtn.on(this.pushEvent, function () {
        if (isTouch) {
            const $this = $(this);
            const $parent = $this.closest(".hero-icon-item");
            $parent.removeClass("active");
            $html.removeClass("hero-popup-is-open");
        }
    });

    $actionBox.on(this.pushEvent, function () {
        if (isTouch) {
            const $this = $(this);
            const $parent = $this.closest(".hero-icon-item");
            $parent.addClass("active").siblings().removeClass("active");
            if (ww < 1200) {
                $html.addClass("hero-popup-is-open");
            }
        }
    });

    $(".explore-more").on(this.pushEvent, (e) => {
        e.preventDefault();
        $("html, body").animate({
            scrollTop: $window.outerHeight()
        }, 1000);
        setTimeout(() => {
            $html.addClass("header-sticky");
        }, 900);
    });

    window.addEventListener("resize", () => {
        setTimeout(() => {
            ww = $window.outerWidth();
        }, 500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/home-hero.js